import { CaptchaResponse } from 'src/app/models/main-page/captcha-response.model';
import { PickupDateHoursPeriodResponse } from 'src/app/models/pickup-date-hours-period/pickup-date-hours-period-response.model';
import { PickupResponse } from 'src/app/models/pickup/pickup-response.model';
import { PreAuthRequest } from 'src/app/models/pre-auth/pre-auth-request.model';
import { PreAuthResponse } from 'src/app/models/pre-auth/pre-auth-response.model';

export interface ApiDataState {
  preAuthRequest?: PreAuthRequest;
  captchaResponse?: CaptchaResponse;
  preAuthResponse?: PreAuthResponse;
  pickupDateHoursPeriodResponse?: PickupDateHoursPeriodResponse;
  pickupResponse?: PickupResponse;
}

export const initialState: ApiDataState = {
  preAuthRequest: undefined,
  captchaResponse: undefined,
  preAuthResponse: undefined,
  pickupDateHoursPeriodResponse: undefined,
  pickupResponse: undefined,
};
